import AgoraRTC from 'agora-rtc-sdk'
import EventEmitter from 'events'

export default class RTCClient {
  constructor() {
    // Options for joining a channel
    this.option = {
      appId: '',
      channel: '',
      uid: '',
      token: '',
    }
    this.client = null
    this.localStream = null
    this._eventBus = new EventEmitter()
  }

  //init client and Join a channel
  joinChannel(option) {
    return new Promise((resolve, reject) => {
      this.client = AgoraRTC.createClient({mode: "rtc", codec: "vp8"})
      this.client.init(option.appid, () => { 
        console.log("init success")
        this.clientListener()
        this.client.join(option.token ? option.token : null, option.channel, Number(option.uid), (uid) => {
          console.log("加入频道: " + this.option.channel + " success, uid: ", uid)
          // this.option = {
          //   appid: option.appid,
          //   token: option.token,
          //   channel: option.channel,
          //   uid: uid,
          // }
          resolve()
        }, (err) => {
          console.error("加入频道 失败", err)
        })
      }, (err) => {
        reject(err)
        console.error(err)
      })
      console.log("加入频道 appId", option.appid)
     })
  }

  publishStream() {
    return new Promise((resolve, reject) => {
      // Create a local stream
      this.localStream = AgoraRTC.createStream({
        streamID: Number(this.option.uid),
        audio: true,
        video: true,
        screen: false
      })
      // Initialize the local stream
      this.localStream.init(() => {
        console.log("成功创建本地流") 
        resolve(this.localStream)
        // Publish the local stream
        this.client.publish(this.localStream, (err) =>  {
          console.log("发布本地流失败")
          console.error(err)
        })
      }, (err) => {
        reject(err)
        console.error("创建本地流失败 ", err)
      })
    })
  }

  clientListener() {
    const client = this.client
    
    client.on('stream-added', (evt) => {
      // The stream is added to the channel but not locally subscribed
      this._eventBus.emit('stream-added', evt)
    })
    client.on('stream-subscribed', (evt) => {
      this._eventBus.emit('stream-subscribed', evt)
    })
    client.on('stream-removed', (evt) => {
      this._eventBus.emit('stream-removed', evt)
    })
    client.on('peer-online', (evt) => {
      this._eventBus.emit('peer-online', evt)
    })
    client.on('peer-leave', (evt) => {
      this._eventBus.emit('peer-leave', evt)
    })
    client.on('mute-video', (evt) => {
      this._eventBus.emit('mute-video', evt)
    })
    client.on('mute-audio', (evt) => {
      this._eventBus.emit('mute-audio', evt)
    })
    client.on('unmute-video', (evt) => {
      this._eventBus.emit('unmute-video', evt)
    })
    client.on('unmute-audio', (evt) => {
      this._eventBus.emit('unmute-audio', evt)
    })
  }

  on(eventName, callback) {
    this._eventBus.on(eventName, callback)
  }

  leaveChannel() {
    return new Promise((resolve, reject) => {
      // Leave the channel
      this.client.unpublish(this.localStream, (err) => {
        console.log(err)
      })
      this.client.leave(() => {
        // Stop playing the local stream
        if (this.localStream.isPlaying()) {
          this.localStream.stop()
        }
        // Close the local stream
        this.localStream.close()
        this.client = null
        resolve()
        console.log("client leaves channel success");
      }, (err) => {
        reject(err)
        console.log("channel leave failed");
        console.error(err);
      })
    })
  }
}